import { useState } from "react";
import ScheduleIcon from "@/shared/ui/icon/ScheduleIcon";

const PricingSchedulingDetail = () => {
  const [showDetailContent, setShowDetailContent] = useState<boolean>(false);
  return (
    <div className={"mb-[12px] mt-[22px] w-full main:mt-[4px]"}>
      <div className={"flex justify-center main:justify-start"}>
        <button
          onClick={() => {
            setShowDetailContent(!showDetailContent);
          }}
          className={
            "flex items-center gap-[4px] text-label2 font-[600] text-primary underline sm:text-body2 main:gap-[6px]"
          }
        >
          기능 더 알아보기
          <svg
            className={`${!showDetailContent && "rotate-180"} main:w-[12px ] h-auto w-[10px]`}
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 10.7914L1.41 11.9999L6 8.07418L10.59 11.9999L12 10.7914L6 5.64844L0 10.7914Z"
              fill="#009EFF"
            />
            <path
              d="M0 5.14291L1.41 6.3515L6 2.42574L10.59 6.3515L12 5.14291L6 0L0 5.14291Z"
              fill="#009EFF"
            />
          </svg>
        </button>
      </div>
      {showDetailContent && (
        <div
          className={
            "mb-[64px] mt-[8px] w-full rounded-lg bg-primary px-[24px] pb-[60px] pt-[20px] sm:mt-[24px] sm:pt-[68px] md:px-[62px] main:mt-[48px] main:px-[80px] main:pb-[64px]"
          }
        >
          <div
            className={
              "w-full text-center text-[10px] font-[800] text-[#EFEBEB] sm:text-title2"
            }
          >
            Training Data Scheduling
          </div>
          <div
            className={
              "mt-[4px] w-full text-center text-title1 font-[800] leading-[1.17] text-white sm:mt-[12px] sm:text-[42px] sm:leading-[1.2] main:mt-[4px] main:text-[50px]"
            }
          >
            변경되는 데이터, <br />
            AI 가 알아서 다시 학습합니다.
          </div>
          <div
            className={
              "rever mt-[46px] flex flex-wrap-reverse items-center gap-[26px] px-[6px] sm:flex-nowrap sm:px-0 main:mt-[90px]"
            }
          >
            <div
              className={
                "w-full sm:w-1/2 sm:min-w-[50%] main:w-[446px] main:min-w-[446px]"
              }
            >
              <img
                src={
                  "https://cdn.winging.app/static/builder/images/pricing_1.png"
                }
                alt={"data image"}
                className={"h-auto w-full"}
              />
            </div>
            <div className={"grow sm:mt-[20px]"}>
              <div
                className={
                  "text-title2 font-[800] leading-[1.20] text-[#F4F5F6] sm:text-[28px] sm:leading-[1.25] main:text-[40px]"
                }
              >
                AI가 학습할 데이터, <br />
                자주 바뀌는 정보인가요?
              </div>
              <div
                className={
                  "mt-[6px] break-keep text-caption1 leading-[1.33] text-[#F4F5F6] sm:text-label2 sm:leading-[1.25]"
                }
              >
                홈페이지에 뉴스나 새 소식, 공지사항 등 자주 변동되는 정보로 AI
                학습을 자주 시켜야 하나요?
              </div>
            </div>
          </div>
          <div
            className={
              "relative mt-[8px] flex w-full flex-wrap px-[6px] sm:px-[28px] main:flex-wrap"
            }
          >
            <img
              src={
                "https://cdn.winging.app/static/builder/images/pricing_2.png"
              }
              alt={"data image"}
              className={
                "absolute right-0 hidden h-auto sm:top-[5%] sm:block sm:w-[50%] main:top-0 main:w-[476px]"
              }
            />
            <div
              className={
                "relative z-10 flex w-full items-start justify-start gap-[16px] pt-[60px] text-[#F4F5F6] main:pt-[72px]"
              }
            >
              <div
                className={
                  "absolute right-0 aspect-square w-[58px] min-w-[58px] sm:left-0 sm:right-auto"
                }
              >
                <ScheduleIcon />
              </div>
              <div className={"sm:pl-[74px] main:w-[450px]"}>
                <div
                  className={
                    "text-title2 font-[800] leading-[1.20] text-[#F4F5F6] sm:text-[28px] sm:leading-[1.25] main:text-[40px]"
                  }
                >
                  AI 학습 일정, <br />
                  원하는대로 설정하세요.
                </div>
                <div
                  className={
                    "mt-[6px] break-keep text-caption1 leading-[1.33] text-[#F4F5F6] sm:text-label2 sm:leading-[1.25]"
                  }
                >
                  기간과 시간을 자유롭게 조합해 <br />
                  데이터 학습 주기를 세밀하게 설정할 수 있습니다.
                </div>
              </div>
            </div>
            <div className={"z-10 w-full"}>
              <img
                src={
                  "https://cdn.winging.app/static/builder/images/pricing_4.png"
                }
                alt={"data image"}
                className={"right-0 block h-auto w-full sm:hidden"}
              />

              <div
                className={
                  "w-full break-keep text-body2 font-[600] leading-[1.25] text-[#F4F5F6] sm:mt-[24px] sm:pl-[74px] sm:leading-[1.35] main:mt-[44px] main:w-[410px] main:text-title2"
                }
              >
                학습이 필요한 데이터의 특성에 맞춰{" "}
                <br className={"inline-block main:hidden"} />
                <span className={"font-[900]"}>
                  자유롭게 학습 일정을 설정
                </span>{" "}
                할 수 있습니다. <br />
                운영 환경에 맞는 유연한 맞춤형 설정으로{" "}
                <br className={"inline-block main:hidden"} />
                불필요한 수집을 줄이고, <br className={""} />
                <span className={"font-[900]"}>
                  효율적인 데이터 관리를 지원
                </span>
                합니다.
              </div>
            </div>
          </div>
          <div
            className={
              "relative z-10 mt-[64px] flex w-full flex-wrap px-[6px] sm:mt-[20%] sm:justify-end sm:px-0 sm:pb-[5%] main:mt-[144px] main:flex-col main:items-end"
            }
          >
            <img
              src={
                "https://cdn.winging.app/static/builder/images/pricing_3.png"
              }
              alt={"data image"}
              className={
                "absolute left-0 z-0 hidden h-auto sm:block sm:w-[40%] md:translate-y-[-20%] main:w-[380px] main:translate-y-[0px]"
              }
            />
            <div
              className={
                "relative z-10 flex w-full flex-row-reverse justify-end sm:w-[60%] sm:flex-row sm:gap-[20px] main:w-[430px]"
              }
            >
              <svg
                className={
                  "absolute right-0 sm:left-0 sm:right-auto main:left-[-72px]"
                }
                width="51"
                height="48"
                viewBox="0 0 51 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.2755 30.206H36.2355L35.547 29.4645C38.046 26.3341 39.5505 22.2975 39.5505 17.849C39.5505 7.99085 32.13 0 22.9755 0C13.821 0 6.4005 8.23799 6.4005 17.849H0L9.792 28.833L20.4 17.849H11.5005C11.5005 10.984 16.6515 5.49199 22.9755 5.49199C29.2995 5.49199 34.4505 11.0114 34.4505 17.849C34.4505 24.659 29.2995 30.206 22.9755 30.206C21.318 30.206 19.7625 29.8215 18.3345 29.1625L14.5605 33.2265C17.034 34.7918 19.89 35.6979 22.9755 35.6979C27.081 35.6979 30.8295 34.0778 33.7365 31.3867L34.425 32.1281V34.2975L47.2005 48L51 43.9359L38.2755 30.206Z"
                  fill="white"
                />
              </svg>
              <div
                className={
                  "w-full text-[#F4F5F6] sm:pl-[72px] main:w-[430px] main:pl-0"
                }
              >
                <div
                  className={
                    "text-title2 font-[800] leading-[1.20] text-[#F4F5F6] sm:text-[28px] sm:leading-[1.25] main:text-[40px]"
                  }
                >
                  설정한 시간에 맞춰 <br />
                  자동으로 학습합니다.{" "}
                </div>
                <div
                  className={
                    "mt-[6px] break-keep text-caption1 leading-[1.33] text-[#F4F5F6] sm:text-label2 sm:leading-[1.25]"
                  }
                >
                  정해진 주기에 따라 데이터를 수집하고
                  <br />
                  AI 에이전트가 최신 정보로 자동 업데이트 됩니다.{" "}
                </div>
              </div>
            </div>
            <div
              className={
                "z-10 flex w-full flex-wrap justify-start sm:w-[60%] sm:justify-end main:w-[430px] main:justify-start"
              }
            >
              <img
                src={
                  "https://cdn.winging.app/static/builder/images/pricing_5.png"
                }
                alt={"data image"}
                className={"block h-auto w-full sm:hidden"}
              />

              <div
                className={
                  "w-full break-keep text-body2 font-[600] leading-[1.25] text-[#F4F5F6] sm:mt-[24px] sm:pl-[72px] sm:leading-[1.35] main:mt-[44px] main:pl-0 main:text-title2"
                }
              >
                <span className={"font-[900]"}>한 번 설정해두면,</span> <br />
                지정한 일정에 따라 데이터가{" "}
                <br className={"inline-block sm:hidden"} /> 주기적으로 수집되고{" "}
                <br className={"inline-block sm:hidden"} />
                변경된 내용은 AI 에이전트 학습에 자동으로 반영됩니다.
                <br className={"inline-block sm:hidden"} />
                <span className={"font-[900]"}> 별도의 수동 업데이트 없이</span>
                도 <br className={"inline-block"} />
                항상 최신 정보를 기반으로 한{" "}
                <br className={"inline-block sm:hidden"} />
                정확한 답변이 유지됩니다.{" "}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingSchedulingDetail;
